import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';

import ShowErrors from '../common/ShowErrors';
import { getBaseName, nl2br } from '../common/Utils';
import { Helmet } from 'react-helmet';
import moment from 'moment';

class CircularContent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            circular: null,
            errors: null
        };
    }

    componentDidMount() {
        this.loadData();

        if (typeof window.writeMenu === "function") { 
            window.writeMenu();
        }


    }

    async loadData() {
        const lang = this.props.match.params.lang;

        const apiParams = new URLSearchParams({
            refNo: this.props.refNo,
            lang: lang
        });
        const apiUrl = `${getBaseName()}/api/circular/content?${apiParams}`;

        const options = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }

        try {            
            const response = await fetch(apiUrl,options);
            if (response.status === 200) {
                const result = await response.json();

                console.log(result);

                this.setState({
                    circular: result
                });
            } else {
                this.props.history.push(`/gateway/${lang}/error`);         
            }
        } catch (error) {
            console.log(error);
        }
    }

    showCircular(circular) {
        const { t } = this.props;
        const REACT_APP_APPS_DOMAIN = `${process.env['REACT_APP_APPS_DOMAIN']}`;
        const gaScript = `
            var _gaq = _gaq || []; 
            _gaq.push(['_setAccount', '${process.env['REACT_APP_GA_ID']}']); 
            _gaq.push(['_setDomainName', '${REACT_APP_APPS_DOMAIN}']); 
            _gaq.push(['_trackPageview']); 
            
            (function () { 
            var ga = document.createElement('script'); ga.type = 'text/javascript'; ga.async = true; 
            ga.src = ('https:' == document.location.protocol ? 'https://ssl' : 'http://www') + '.google-analytics.com/ga.js'; 
            var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(ga, s); 
            })();
        `;

        const ga4ScriptId = `${process.env['REACT_APP_GA4_ID']}`;

        const ga4Script = `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
        
            gtag('config', '${process.env['REACT_APP_GA4_ID']}');      
        `;
        
        const appendixList = []; 
        if (circular.appendixDocList && circular.appendixDocList.length > 0) {

            appendixList.push(
                <p>
                    {t('labels.appendixDoc')}
                    <br/>
                {circular.appendixDocList.map((appendix) =>
                    <Link key={appendix.refNo} to={`openAppendix?refNo=${circular.refNo}&appendix=${appendix.refNo}`}>
                        {appendix.caption}<br/>
                    </Link>
                    
                )}
                </p>
            );
        }

        return (
            <div>
                <Helmet>
                    <title>{circular.title} | {t('common:sfc')}</title>
                    <meta name='date' content={t('common:date.metaformatter',{date:moment(circular.releasedDate, "YYYY-MM-DDTHH:mm:ss").toDate()})}></meta>
                    <script>{gaScript}</script>
                    <script async src={`https://www.googletagmanager.com/gtag/js?id=${ga4ScriptId}`}></script>
                    <script>{ga4Script}</script>
                </Helmet>
                <div>
                    <h1 dangerouslySetInnerHTML={{ __html: nl2br(circular.title)}}></h1>
                </div>
                <div>
                    <small>{t('labels.releasedDate',{date:moment(circular.releasedDate, "YYYY-MM-DDTHH:mm:ss").toDate()})}</small>
                </div>
                <br/>
                <br/>
                <div  className="newsc"  dangerouslySetInnerHTML={{ __html: circular.html}}></div>
                <br/>
                <p>
                    <Link to={`openFile?refNo=${circular.refNo}`}>
                        {t('labels.mainAttachmentDnldLink')}
                    </Link>
                </p>
                <br/>
                {appendixList}
                <div>
                    <small>{t('labels.lastUpdateDate',{date:moment(circular.modificationTime, "YYYY-MM-DDTHH:mm:ss").toDate()})}</small>
                </div>
            </div>
        );
    }

    render() {
        const { circular, errors } = this.state;
        window.scrollTo(0, 0);
        if (circular) {
            return this.showCircular(circular);
        } else if (errors) {
            return (<ShowErrors errors={errors}/>);
        } else {
            return (<span>Loading...</span>);
        }
    }

}

export default withRouter(withTranslation()(CircularContent));